var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-container"},[_c('a-result',{staticClass:"coming-message",attrs:{"title":"Coming June 2022!"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{staticClass:"tf-primary tf-btn-primary",attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("\n        Go Dashboard\n      ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }